import log from 'loglevel'
import { isNil } from 'lodash/fp'
import axios from 'axios'

import apiKeys from '../../../../cdk/bapp/lib/lambda-api/src/apiKey.json'

const env = process.env['ENV'] as string
export const url = !isNil(process.env['LOCAL'])
  ? 'http://localhost:14000/v1/entry'
  : ({
      prd: 'https://api.bapp.terashite.jp/v1/entry',
      stg: 'https://api-stg.bapp.terashite.jp/v1/entry',
      int: 'https://api-int.bapp.dev.terashite.jp/v1/entry',
      dev: 'https://api-dev.bapp.terashite.jp/v1/entry',
      exp: 'https://api-exp.bapp.dev.terashite.jp/v1/entry'
    }[env] as string)
const apiKey = apiKeys[env]

log.setLevel(log.levels.DEBUG)

export const getAgreemnet = async (id: string): Promise<any | undefined> => {
  const { data } = await axios
    .get(`${url}/agreement/${id}`, {
      headers: { 'X-Api-Key': apiKey }
    })
    .catch((error) => {
      log.error(error)
      return { data: undefined, status: 500 }
    })
  return data
}
